import { cn } from "@universe/ui/lib/utils";

import useCurrencyFormatter from "@/hooks/useCurrencyFormatter";

import { formatTransactionAmount } from "./ledger/utils";

export default function FormattedCurrencyAmount({
  balance = 0,
  product,
  forceNegative = false,
  forcePositive = false,
  numberOnly = false,
  className,
}: {
  balance: number;
  product: string;
  forceNegative?: boolean;
  forcePositive?: boolean;
  numberOnly?: boolean;
  className?: string;
}) {
  const { formatCurrency } = useCurrencyFormatter();

  return (
    <div
      className={cn(
        "text-base lg:text-lg font-medium",
        forcePositive || (!forceNegative && balance && balance > 0)
          ? "text-green-600 font-semibold"
          : "text-primary",
        className
      )}
    >
      {formatTransactionAmount(
        balance,
        product,
        formatCurrency,
        forceNegative,
        forcePositive,
        numberOnly
      )}
    </div>
  );
}
